import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { PopupModal } from '@/components/common/Modal'
import { mapGetters } from 'vuex'
import * as types from '@calendar/store/types'
@Component({
    components: {
        PopupModal
    },
    computed: {
        ...mapGetters({
            folderListTree: types.FOLDER_LIST_TREE
        })
    }
})
export default class FolderModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean
    @Prop({ type: Object }) value!: calendar.CalendarItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    folderListTree!: any

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    /**
     * 현재 아이템의 폴더를 불러옵니다
     */
    get folderList(): ItemList<calendar.Folder> {
        let allowList = this.folderListTree.companylist.items
            .filter((x: any) => { if (x.create) { return x; } });
        if (allowList.length) {
            return [
                ...this.folderListTree.mylist.items, 
                ...this.folderListTree.companylist.items, 
                ...this.folderListTree.deptlist.items
            ];
        } else {
            return [
                ...this.folderListTree.mylist.items, 
                ...this.folderListTree.deptlist.items
            ];
        }
    }
}
